export enum CreateReportScheduleSteps {
  Type,
  Parameters,
  Frequency,
  Format,
  Notifications,
  Summary,
}
